import { localStorageService } from './localStorageService';

class ApiClient {
    async request(endpoint, options = {}) {
        const url = `/api${endpoint}`;
        const token = localStorageService.getAuthToken();
        
        // Separate headers from other options to avoid overwriting merged headers
        const { headers: optionHeaders, ...otherOptions } = options;
        
        const config = {
            ...otherOptions,
            headers: {
                'Content-Type': 'application/json',
                ...(token && { 'X-App-Token': token }),
                ...optionHeaders,
            },
        };

        const response = await fetch(url, config);
        return this.handleResponse(response);
    }

    async handleResponse(response) {
        if (!response.ok) {
            let data = {};
            try {
                data = await response.json();
            } catch {
                // non-JSON error body (e.g. an infra error page on a cold start)
            }
            console.log("ERROR", data);
            const errorMessage = data.errors?.[0]?.msg || `HTTP error! status: ${response.status}`;
            const error = new Error(errorMessage);
            error.status = response.status;
            throw error;
        }
        return response.json();
    }

    async refreshToken() {
        // TODO: Implement refresh token functionality when backend supports it
        throw new Error('Refresh token functionality not implemented yet');
    }

    get(endpoint) { 
        return this.request(endpoint, { method: 'GET' }); 
    }
    
    post(endpoint, data) { 
        return this.request(endpoint, { 
            method: 'POST', 
            body: JSON.stringify(data) 
        }); 
    }
    
    put(endpoint, data) { 
        return this.request(endpoint, { 
            method: 'PUT', 
            body: JSON.stringify(data) 
        }); 
    }
    
    delete(endpoint) { 
        return this.request(endpoint, { method: 'DELETE' }); 
    }
}

export const apiClient = new ApiClient();